import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';
const SvgGlobe = ({
  alt = 'Globe Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}
    <path
      fill="currentColor"
      d="M12 21.75c.347 0 1.266-.337 2.231-2.269.413-.83.769-1.837 1.031-2.981H8.738c.262 1.144.618 2.152 1.03 2.981.966 1.931 1.885 2.269 2.232 2.269Zm-3.633-7.5h7.266a21.682 21.682 0 0 0 0-4.5H8.367a21.682 21.682 0 0 0 0 4.5Zm.37-6.75h6.525c-.262-1.144-.618-2.152-1.03-2.981C13.265 2.587 12.346 2.25 12 2.25c-.347 0-1.266.337-2.231 2.269C9.356 5.349 9 6.356 8.738 7.5Zm9.155 2.25c.07.727.103 1.481.103 2.25 0 .769-.037 1.523-.103 2.25h3.596A9.888 9.888 0 0 0 21.75 12a9.71 9.71 0 0 0-.262-2.25h-3.596Zm2.756-2.25a9.788 9.788 0 0 0-4.612-4.378c.66 1.2 1.186 2.695 1.528 4.378h3.09-.006Zm-14.217 0c.342-1.683.867-3.173 1.528-4.378A9.788 9.788 0 0 0 3.347 7.5h3.089-.005ZM2.513 9.75A9.885 9.885 0 0 0 2.25 12c0 .773.09 1.528.263 2.25h3.595A23.442 23.442 0 0 1 6.005 12c0-.769.037-1.523.103-2.25H2.513Zm13.523 11.128a9.788 9.788 0 0 0 4.612-4.378H17.56c-.342 1.683-.867 3.173-1.528 4.378h.005Zm-8.072 0c-.66-1.2-1.186-2.695-1.528-4.378h-3.09a9.788 9.788 0 0 0 4.613 4.378h.005ZM12 24a12 12 0 1 1 0-24 12 12 0 0 1 0 24Z"
    />
  </svg>
);
export default SvgGlobe;
